import React, { Component } from 'react';
import { Grid, Row, Col, Modal, Form, FormGroup, FormControl, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap';

import { TableButton } from '../TableButton';
import { HandleDialog } from '../HandleDialog';
import { ComponentStyles } from './componentStyles/ComponentStyles';
import { SimpleTextDataIdentifier } from './dataIdentifiers/SimpleTextDataIdentifier';
import { ImageDataIdentifier } from './dataIdentifiers/ImageDataIdentifier';
import { QrCodeDataIdentifier } from './dataIdentifiers/QrCodeDataIdentifier';
import { DayTimesheetDataIdentifier } from './dataIdentifiers/DayTimesheetDataIdentifier';
import { PassingIntervalsDataIdentifier } from './dataIdentifiers/PassingIntervalsDataIdentifier';
import { DayVerticalTimesheetDataIdentifier } from './dataIdentifiers/DayVerticalTimesheetDataIdentifier';
import { VerticalDayTimesheetDataIdentifier } from './dataIdentifiers/VerticalDayTimesheetDataIdentifier';
import { VerticalComposedDayTimesheetDataIdentifier } from './dataIdentifiers/VerticalComposedDayTimesheetDataIdentifier';
import { LineInformationDataIdentifier } from './dataIdentifiers/LineInformationDataIdentifier';
import { HorizontalStopsListDataIdentifier } from './dataIdentifiers/HorizontalStopsListDataIdentifier';
import { VerticalStopsListDataIdentifier } from './dataIdentifiers/VerticalStopsListDataIdentifier';
import { HorizontalTabularDayTimesheetDataIdentifier } from './dataIdentifiers/HorizontalTabularDayTimesheetDataIdentifier';
import { VerticalTabularDayTimesheetDataIdentifier } from './dataIdentifiers/VerticalTabularDayTimesheetDataIdentifier';
import { ExceptionsDataIdentifier } from './dataIdentifiers/ExceptionsDataIdentifier';
import { DayTimesheetParameters } from './parameters/DayTimesheetParameters';
import { GlobalParameters } from './parameters/GlobalParameters';
import { SchematicMapDataIdentifier } from './dataIdentifiers/SchematicMapDataIdentifier';
import { LineCaptionDataIdentifier } from './dataIdentifiers/LineCaptionDataIdentifier';

export class ComponentConfigurationProperties extends Component {
    constructor(props) {
        super(props);

        const infoElements = {
            simpletext: SimpleTextDataIdentifier,
            image: ImageDataIdentifier,
            qrcode: QrCodeDataIdentifier,
            dayverticaltimesheet: DayVerticalTimesheetDataIdentifier,
            daytimesheet: DayTimesheetDataIdentifier,
            compactdaytimesheet: DayTimesheetDataIdentifier,
            verticaldaytimesheet: VerticalDayTimesheetDataIdentifier,
            horizontaltabulardaytimesheet: HorizontalTabularDayTimesheetDataIdentifier,
            verticaltabulardaytimesheet: VerticalTabularDayTimesheetDataIdentifier,
            verticalcomposeddaytimesheet: VerticalComposedDayTimesheetDataIdentifier,
            lineinformation: LineInformationDataIdentifier,
            horizontalstopslist: HorizontalStopsListDataIdentifier,
            verticalstopslist: VerticalStopsListDataIdentifier,
            exceptions: ExceptionsDataIdentifier,
            passingintervals: PassingIntervalsDataIdentifier,
            schematicmap: SchematicMapDataIdentifier,
            linecaption: LineCaptionDataIdentifier
        };
        const parametersElements = {
            daytimesheet: DayTimesheetParameters,
            dayverticaltimesheet: DayTimesheetParameters,
            compactdaytimesheet: DayTimesheetParameters,
            verticaldaytimesheet: DayTimesheetParameters,
            horizontaltabulardaytimesheet: DayTimesheetParameters,
            verticaltabulardaytimesheet: DayTimesheetParameters,
            verticalcomposeddaytimesheet: DayTimesheetParameters,
            lineinformation: GlobalParameters,
            horizontalstopslist: GlobalParameters,
            verticalstopslist: GlobalParameters,
            passingintervals: GlobalParameters,
        };
        const infoConfiguration = {
            enable: false,
            showModal: false,
            element: null
        };
        const parametersConfiguration = {
            enable: false,
            showModal: false,
            element: null
        }

        // Add Info / Configuration
        if (undefined !== infoElements[this.props.component.type.toLowerCase()]) {
            infoConfiguration.enable = true;
            infoConfiguration.element = infoElements[this.props.component.type.toLowerCase()];
        }

        if (undefined !== parametersElements[this.props.component.type.toLowerCase()]) {
            parametersConfiguration.enable = true;
            parametersConfiguration.element = parametersElements[this.props.component.type.toLowerCase()];
        }

        this.state = {
            component: {
                id: this.props.component.id,
                internalId: this.props.component.internalId,
                modified: this.props.component.modified,
                geometries: this.props.component.geometries.map(g => ({
                    width: g.width,
                    height: g.height,
                    positionX: g.absolutePositionAxisX,
                    positionY: g.absolutePositionAxisY,
                    positionZ: g.positionZ,
                    offsetX: g.offsetX,
                    offsetY: g.offsetY
                })),
                dataIdentifier: this.props.component.dataIdentifier,
                configuration: this.props.component.configuration,
                parameters: this.props.component.parameters,
                type: this.props.component.type,
                fonts: this.props.component.fonts.slice(0),
                backgrounds: this.props.component.backgrounds.slice(0),
                margins: this.props.component.margins.slice(0),
                circleElements: this.props.component.circleElements.slice(0)
            },
            inputStyles: {
                width: null,
                height: null,
                positionX: null,
                positionY: null,
                positionZ: null
            },
            configurations: {
                infoElements: infoElements,
                parametersElements: parametersElements,
                infoConfiguration: infoConfiguration,
                parametersConfiguration: parametersConfiguration,
                showStylesConfiguration: false

            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            geometriesAllowed: [
                "VerticalTabularDayTimesheet"
            ]
        };
    }

    // -----------------------

    componentWillReceiveProps(nextProps) {
        const { component } = nextProps;
        const { configurations } = this.state;

        // Adicional Info / Configuration
        if (undefined !== configurations.infoElements[component.type.toLowerCase()]) {
            configurations.infoConfiguration.enable = true;
            configurations.infoConfiguration.element = configurations.infoElements[component.type.toLowerCase()];
        }
        else {
            configurations.infoConfiguration.enable = false;
            configurations.infoConfiguration.element = null;
        }

        // Parameters
        if (undefined !== configurations.parametersElements[component.type.toLowerCase()]) {
            configurations.parametersConfiguration.enable = true;
            configurations.parametersConfiguration.element = configurations.parametersElements[component.type.toLowerCase()];
        }
        else {
            configurations.parametersConfiguration.enable = false;
            configurations.parametersConfiguration.element = null;
        }

        this.setState({
            component: {
                id: component.id,
                internalId: component.internalId,
                modified: component.modified,
                geometries: this.props.component.geometries.map(g => ({
                    width: g.width,
                    height: g.height,
                    positionX: g.absolutePositionAxisX,
                    positionY: g.absolutePositionAxisY,
                    positionZ: g.positionZ,
                    offsetX: g.offsetX,
                    offsetY: g.offsetY
                })),
                dataIdentifier: component.dataIdentifier,
                configuration: component.configuration,
                parameters: component.parameters,
                type: component.type,
                fonts: component.fonts.slice(0),
                backgrounds: component.backgrounds.slice(0),
                margins: component.margins.slice(0),
                circleElements: component.circleElements.slice(0)
            },
            configurations: configurations
        });
    }

    // -----------------------

    onSave() {
        if (null !== this.props.onSaveComponentProperties && undefined !== this.props.onSaveComponentProperties) {
            const { component } = this.state;

            const inputStyles = {
                width: null,
                height: null,
                positionX: null,
                positionY: null,
                positionZ: null
            }

            if (0 >= component.geometries[0].width.length) {
                inputStyles.width = "error"
            }
            if (0 >= component.geometries[0].height.length) {
                inputStyles.height = "error"
            }
            if (0 >= component.geometries[0].positionX.length) {
                inputStyles.positionX = "error"
            }
            if (0 >= component.geometries[0].positionY.length) {
                inputStyles.positionY = "error"
            }
            if (0 >= component.geometries[0].positionZ.length) {
                inputStyles.positionZ = "error"
            }

            this.setState({
                inputStyles: inputStyles
            });

            if (null === inputStyles.width && null === inputStyles.height && null === inputStyles.positionX && null === inputStyles.positionY && null === inputStyles.positionZ) {
                this.props.onSaveComponentProperties(component);
            }
        }
    }

    onParameter() {
        const { component } = this.state;

        if (undefined !== component.internalId && null !== component.internalId) {
            const { configurations } = this.state;

            configurations.parametersConfiguration.showModal = true;

            this.setState({
                configurations: configurations
            });
        }
    }

    onHideParametersConfigurationModal() {
        const { configurations } = this.state;

        configurations.parametersConfiguration.showModal = false;

        this.setState({
            configurations: configurations
        });
    }

    onConfigureInfo() {
        const { component } = this.state;

        if (undefined !== component.internalId && null !== component.internalId) {
            const { configurations } = this.state;

            configurations.infoConfiguration.showModal = true;

            this.setState({
                configurations: configurations
            });
        }
    }

    onHideInfoConfigurationModal() {
        const { configurations } = this.state;

        configurations.infoConfiguration.showModal = false;

        this.setState({
            configurations: configurations
        });
    }

    onConfigureStyles() {
        const { component } = this.state;

        if (undefined !== component.internalId && null !== component.internalId) {
            const { configurations } = this.state;

            configurations.showStylesConfiguration = true;

            this.setState({
                configurations: configurations
            });
        }
    }

    onHideStylesConfigurationModal() {
        const { configurations } = this.state;

        configurations.showStylesConfiguration = false;

        this.setState({
            configurations: configurations
        });
    }

    // -----------------------

    onDeleteSelectedComponent(component) {
        this.setState({
            dialog: {
                show: true,
                message: "Tem a certeza que pretende eliminar o componente selecionado?",
                style: "warning",
                icon: "alert",
                title: "Aviso",
                argument: {
                    component: component
                }
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        if (isToExecute) {
            this.props.onDeleteSelectedComponent(argument.component);
        }

        this.setState({
            dialog: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: "",
                argument: undefined
            }
        });
    }

    // -----------------------

    onSelectData(dataId, isToClose) {
        const { component } = this.state;

        this.props.onComponentChangeValue({ target: { value: `${dataId}` } }, "dataIdentifier");

        component.dataIdentifier = dataId;
        component.modified = true;

        if (isToClose) {
            this.onHideInfoConfigurationModal();
        }

        this.setState({
            component: component
        });
    }

    onConfigureData(configuration, isToClose) {
        const { component } = this.state;

        this.props.onComponentChangeValue({ target: { value: `${configuration}` } }, "configuration");

        component.configuration = configuration;
        component.modified = true;

        if (isToClose) {
            this.onHideInfoConfigurationModal();
        }

        this.setState({
            component: component
        });
    }

    onParameterData(parameters, isToClose) {
        const { component } = this.state;

        this.props.onComponentChangeValue({ target: { value: parameters } }, "parameters");

        component.parameters = parameters;
        component.modified = true;

        if (isToClose) {
            this.onHideParametersConfigurationModal();
        }

        this.setState({
            component: component
        });
    }

    onUpdateStyles(data, target) {
        const { component } = this.state;

        const styles = data.map(d => Object.assign({}, d));
        this.props.onComponentChangeValue({ target: { value: styles } }, target);

        component[target] = styles;
        this.setState({
            component: component
        });
    }

    onComponentGeometryChangeValue(component, data, target, index) {
        component.geometries[index][target] = data.target.value;

        this.props.onComponentChangeValue({ target: { value: component.geometries } }, 'geometries');

        this.setState({
            component: component
        });
    }

    onAddGeometry(component) {
        const lastGeometry = component.geometries[component.geometries.length - 1];

        const newY = lastGeometry.positionY + lastGeometry.height;

        const newGeometry = {
            width: lastGeometry.width,
            height: lastGeometry.height,
            positionX: lastGeometry.positionX,
            positionY: newY,
            positionZ: lastGeometry.positionZ,
            offsetX: 0,
            offsetY: 0
        };

        // Update component
        const updated = {
            ...component,
            geometries: [...component.geometries, newGeometry]
        };

        this.props.onComponentChangeValue({ target: { value: updated.geometries } }, 'geometries');
        this.setState({ component: updated });
    }

    onRemoveGeometry(component, geometryIndex) {
        if (component.geometries.length === 1) {
            this.onDeleteSelectedComponent(component);
            return;
        }

        const newGeometries = component.geometries.filter((_, idx) => idx !== geometryIndex);

        // Determine the new selectedGeometryIndex
        let newSelectedIndex = component.selectedGeometryIndex;

        if (geometryIndex === component.selectedGeometryIndex) {
            newSelectedIndex = Math.max(geometryIndex - 1, 0);
        } else if (component.selectedGeometryIndex >= newGeometries.length) {
            newSelectedIndex = newGeometries.length - 1;
        }

        const updated = {
            ...component,
            geometries: newGeometries
        };

        updated.selectedGeometryIndex = newSelectedIndex;

        this.props.onComponentChangeValue({ target: { value: newSelectedIndex } }, 'selectedGeometryIndex');
        this.props.onComponentChangeValue({ target: { value: newGeometries } }, 'geometries');
        this.setState({ component: updated });
    }

    onMoveGeometryUp(component, geometryIndex) {
        if (geometryIndex <= 0) {
            return;
        }

        const newGeometries = [...component.geometries];

        [newGeometries[geometryIndex - 1], newGeometries[geometryIndex]] = [newGeometries[geometryIndex], newGeometries[geometryIndex - 1]];

        const updatedSelectedIndex = component.selectedGeometryIndex === geometryIndex
            ? geometryIndex - 1
            : component.selectedGeometryIndex === geometryIndex - 1
                ? geometryIndex
                : component.selectedGeometryIndex;
        const updated = {
            ...component,
            geometries: newGeometries,
        };

        updated.selectedGeometryIndex = updatedSelectedIndex;

        this.props.onComponentChangeValue({ target: { value: updatedSelectedIndex } }, 'selectedGeometryIndex');
        this.props.onComponentChangeValue({ target: { value: newGeometries } }, 'geometries');
        this.setState({ component: updated });
    }

    onMoveGeometryDown(component, geometryIndex) {
        const lastIndex = component.geometries.length - 1;
        if (geometryIndex >= lastIndex) {
            return;
        }

        const newGeometries = [...component.geometries];
        [newGeometries[geometryIndex], newGeometries[geometryIndex + 1]] = [newGeometries[geometryIndex + 1], newGeometries[geometryIndex]];

        const updatedSelectedIndex = component.selectedGeometryIndex === geometryIndex
            ? geometryIndex + 1
            : component.selectedGeometryIndex === geometryIndex + 1
                ? geometryIndex
                : component.selectedGeometryIndex;

        const updated = {
            ...component,
            geometries: newGeometries,
        };

        updated.selectedGeometryIndex = updatedSelectedIndex;

        this.props.onComponentChangeValue({ target: { value: updatedSelectedIndex } }, 'selectedGeometryIndex');
        this.props.onComponentChangeValue({ target: { value: newGeometries } }, 'geometries');

        this.setState({ component: updated });
    }

    onChangeSelectedGeometry(component, geometryIndex) {
        component.selectedGeometryIndex = geometryIndex;

        this.props.onComponentChangeValue({ target: { value: component.selectedGeometryIndex } }, 'selectedGeometryIndex');

        this.setState({ component: component });
    }


    // -----------------------

    renderParametersElementButton(configuration) {
        if (!configuration.enable) {
            return null;
        }

        return (
            <Button bsStyle="default" onClick={() => this.onParameter()}>PARÂMETROS</Button>
        );
    }

    renderParametersElementModal(configuration, parameters) {
        if (!configuration.enable || !configuration.showModal) {
            return null;
        }

        return (
            <Modal show={configuration.showModal}
                bsSize="large" >
                <Modal.Header>
                    <Modal.Title>PARÂMETROS</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        React.createElement(
                            configuration.element,
                            {
                                parameters: parameters,
                                appName: this.props.appName,
                                onParameterData: (a, b) => this.onParameterData(a, b),
                                onCancel: () => this.onHideParametersConfigurationModal()
                            })
                    }
                </Modal.Body>
            </Modal>
        );
    }

    renderSpecificInfoElementButton(configuration) {
        if (!configuration.enable) {
            return null;
        }

        return (
            <Button bsStyle="default" onClick={() => this.onConfigureInfo()}>CONFIGURAÇÃO</Button>
        );
    }

    renderSpecificInfoElementModal(configuration, dataIdentifier, componentConfiguration) {
        if (!configuration.enable || !configuration.showModal) {
            return null;
        }

        return (
            <Modal show={configuration.showModal}
                bsSize="large" >
                <Modal.Header>
                    <Modal.Title>CONFIGURAÇÃO</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        React.createElement(
                            configuration.element,
                            {
                                selectedData: dataIdentifier,
                                appName: this.props.appName,
                                configuration: componentConfiguration,
                                onSelectData: (a, b) => this.onSelectData(a, b),
                                onConfigureData: (a, b) => this.onConfigureData(a, b),
                                onCancel: () => this.onHideInfoConfigurationModal()
                            })
                    }
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { inputStyles, configurations, dialog, geometriesAllowed } = this.state;
        const { component } = this.props;

        const useGeometries = geometriesAllowed.includes(component.type);
        const geometryIndex = Number(component.selectedGeometryIndex) || 0;

        return (
            <div className="margin-top-15">
                <Grid fluid>
                    <Row>
                        <Col className="no-padding-left" sm={12}>
                            <div className="control-label">Configuração Elemento</div>
                        </Col>
                    </Row>
                    <Row className="margin-top-15">
                        <Col className="no-padding-left" sm={12}>
                            <Form horizontal>
                                <div style={{ display: "flex" }}>
                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentPositionX"
                                            validationState={inputStyles.positionX} >
                                            <Col componentClass={ControlLabel} sm={4}>X</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Posição no Eixo X"
                                                    value={component.geometries[geometryIndex].positionX}
                                                    onChange={(e) => this.onComponentGeometryChangeValue(component, e, 'positionX', geometryIndex)} />
                                            </Col>
                                        </FormGroup>
                                    </div>

                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentWidth"
                                            validationState={inputStyles.width} >
                                            <Col componentClass={ControlLabel} sm={4}>L</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Largura do Elemento"
                                                    value={component.geometries[geometryIndex].width}
                                                    onChange={(e) => this.onComponentGeometryChangeValue(component, e, 'width', geometryIndex)} />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                <div style={{ display: "flex" }}>
                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentPositionY"
                                            validationState={inputStyles.positionY} >
                                            <Col componentClass={ControlLabel} sm={4}>Y</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Posição no Eixo Y"
                                                    value={component.geometries[geometryIndex].positionY}
                                                    onChange={(e) => this.onComponentGeometryChangeValue(component, e, 'positionY', geometryIndex)} />
                                            </Col>
                                        </FormGroup>
                                    </div>

                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentHeight"
                                            validationState={inputStyles.height} >
                                            <Col componentClass={ControlLabel} sm={4}>A</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Altura do Elemento"
                                                    value={component.geometries[geometryIndex].height}
                                                    onChange={(e) => this.onComponentGeometryChangeValue(component, e, 'height', geometryIndex)} />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                <div style={{ display: "flex" }}>
                                    <div style={{ width: "50%" }}>
                                        <FormGroup bsSize="small"
                                            controlId="formComponentPositionZ"
                                            validationState={inputStyles.positionZ} >
                                            <Col componentClass={ControlLabel} sm={4}>Z</Col>
                                            <Col sm={8}>
                                                <FormControl
                                                    type="number"
                                                    step={1}
                                                    placeholder="Posição no Eixo Z"
                                                    value={component.geometries[geometryIndex].positionZ}
                                                    onChange={(e) => this.onComponentGeometryChangeValue(component, e, 'positionZ', geometryIndex)} />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                <ButtonToolbar>
                                    <div className="btn-group" style={{ marginRight: 10 }}>
                                        {this.renderParametersElementButton(configurations.parametersConfiguration)}
                                        {this.renderSpecificInfoElementButton(configurations.infoConfiguration)}
                                        <Button
                                            bsStyle="default"
                                            onClick={() => this.onConfigureStyles()}
                                        >
                                            ESTILOS
                                        </Button>
                                    </div>
                                    <Button
                                        bsStyle="default"
                                        className="pull-left"
                                        style={{ marginRight: 10 }}
                                        onClick={() => this.onDeleteSelectedComponent(component)}
                                    >
                                        ELIMINAR COMPONENTE
                                    </Button>
                                </ButtonToolbar>
                                <div style={{ display: "flex" }}>
                                    {useGeometries && (
                                        <div style={{ marginTop: "10px", width: "100%" }}>
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "8px",
                                                gap: "8px"
                                            }}>
                                                <span style={{ fontWeight: "bold", fontSize: "13px" }}>
                                                    ELEMENTOS
                                                </span>

                                                <TableButton
                                                    icon="icon-plus"
                                                    title="Adicionar"
                                                    onClick={() => this.onAddGeometry(component)}
                                                />
                                            </div>

                                            {component.geometries.length >= 1 && (
                                                <div
                                                    style={{
                                                        marginTop: "8px",
                                                        maxHeight: "200px",
                                                        overflowY: "auto",
                                                        paddingRight: "4px"
                                                    }}
                                                >
                                                    {component.geometries.map((geo, idx) => {
                                                        const isFirst = idx === 0;
                                                        const isLast = idx === component.geometries.length - 1;
                                                        const isSelected = geometryIndex === idx;
                                                        const realIndex = idx + 1;

                                                        return (
                                                            <div
                                                                key={realIndex}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "6px 8px",
                                                                    border: isSelected ? "2px solid #3399ff" : "1px solid #ddd",
                                                                    borderRadius: "6px",
                                                                    marginBottom: "4px",
                                                                    background: isSelected ? "#e6f0ff" : "#fafafa",
                                                                    fontSize: "12px"
                                                                }}
                                                                onClick={() => this.onChangeSelectedGeometry(component, idx)}
                                                            >
                                                                <div style={{ flexGrow: 1, fontWeight: isSelected ? "bold" : "normal" }}>
                                                                    #{realIndex} - X:{geo.positionX}, Y:{geo.positionY}
                                                                </div>

                                                                <div style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "4px"
                                                                }}>
                                                                    <TableButton
                                                                        icon={`icon-menu icon-rotate-up ${isFirst ? "icon-disabled" : ""}`}
                                                                        title="Mover para Cima"
                                                                        disabled={isFirst}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (!isFirst) this.onMoveGeometryUp(component, idx);
                                                                        }}
                                                                    />

                                                                    <TableButton
                                                                        icon={`icon-menu icon-rotate-down ${isLast ? "icon-disabled" : ""}`}
                                                                        title="Mover para Baixo"
                                                                        disabled={isLast}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (!isLast) this.onMoveGeometryDown(component, idx);
                                                                        }}
                                                                    />

                                                                    <TableButton
                                                                        icon="icon-trash"
                                                                        title="Remover"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            this.onRemoveGeometry(component, idx);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {this.renderParametersElementModal(configurations.parametersConfiguration, component.parameters)}
                                {this.renderSpecificInfoElementModal(configurations.infoConfiguration, component.dataIdentifier, component.configuration)}
                            </Form>
                        </Col>
                    </Row>
                </Grid>

                <Modal
                    enforceFocus={false}
                    show={configurations.showStylesConfiguration}
                    bsSize="large"
                    onHide={() => this.onHideStylesConfigurationModal()} >
                    <Modal.Header
                        closeLabel="Fechar"
                        closeButton >
                        <Modal.Title>Estilos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ComponentStyles
                            appName={this.props.appName}
                            fonts={component.fonts.slice(0)}
                            backgrounds={component.backgrounds.slice(0)}
                            circleElements={component.circleElements.slice(0)}
                            margins={component.margins.slice(0)}
                            componentType={component.type}
                            onUpdateStyles={(a, b) => this.onUpdateStyles(a, b)} />
                    </Modal.Body>
                </Modal>

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
